import {getFilterGroupValue, getFilterGroupValues} from "../../../misc/utils";
import {getCurrentLayout} from "../../appLayout";
import {getTotalPrice, toFixedFeatureCost, toFixedPrice} from "../../../misc/helpers";
import {isProd} from "../../../misc/fabricatorHardcode";

export const SIMILAR_FILTER_GROUP_NAME = "Collection";

/**
 * @param cartItem {object}
 * @param filterGroups {array}
 * @returns {array} // [featureCollectionInterface] or null
 */
export const getFeaturesCollectionsList = (cartItem, filterGroups) => {

  if (!cartItem || !cartItem.cartFeature || !cartItem.partId.includes("countertop") || isProd() || !filterGroups.length) {
    return null
  }

  const parent = cartItem.cartFeature.getParent ? cartItem.cartFeature.getParent() : null;
  if (!parent) {
    return null
  }

  const filterGroup = filterGroups.find(fGroup => fGroup.name === SIMILAR_FILTER_GROUP_NAME);
  if (!filterGroup) {
    return null
  }

  const cartFeatureFilters = getFilterGroupValues(cartItem.cartFeature, filterGroup) || [];

  let featuresCollectionsList = [];

  const layout = getCurrentLayout();
  const navFeatures = layout.designNavigationItems({part: parent}, {}, "", false, true);
  for (let i = 0; i < navFeatures.length; i++) {
    const navFeature = navFeatures[i];
    const featureFilters = getFilterGroupValues(navFeature.part, filterGroup);
    if (Array.isArray(featureFilters)) {
      featureFilters.forEach(filterValueId => {
        if (!cartFeatureFilters.some(cartFeatureFilter => cartFeatureFilter === filterValueId)) {
          let collectionObject = featuresCollectionsList.find(colObject => colObject.id === filterValueId);
          if (collectionObject) {
            collectionObject.features.push(navFeature.part)
          } else {
            collectionObject = {id: filterValueId, features: [navFeature.part]};
            featuresCollectionsList.push(collectionObject);
          }
        }
      })
    }
  }

  featuresCollectionsList = featuresCollectionsList.sort((a, b) => a.id - b.id); // sort by collection id
  console.log("featuresCollectionsList", featuresCollectionsList);

  return featuresCollectionsList

}

/**
 * @param cartItem {cartItemInterface}
 * @param addedCountertops {[cartItemInterface]}
 * @param featureCollection {object}
 * @param totalCountertopsQuantity {number}
 * @param quoteIndex {number}
 * @param filterGroups {array}
 * @returns {similarItemObjectInterface} // or null
 */
export const getSimilarItemInfoObject = (
  cartItem,
  addedCountertops,
  featureCollection,
  totalCountertopsQuantity,
  quoteIndex,
  filterGroups,
) => {
  let feature = null;
  const fromCartItemName = cartItem.cartFeature.getSplittedFeatureName();
  // console.log("fromCartItemName", fromCartItemName);
  if (fromCartItemName) {
    // if (
    //   (fromCartItemName.includes("2cm") && addedCountertops.some(cItem => cItem.cartFeature && cItem.cartFeature.getSplittedFeatureName().includes("3cm")))
    //   || (fromCartItemName.includes("3cm") && addedCountertops.some(cItem => cItem.cartFeature && cItem.cartFeature.getSplittedFeatureName().includes("2cm")))
    // ) {
    //   feature = featureCollection.features.find(currentFeature => ["2cm", "3cm"].some(inName => currentFeature.getSplittedFeatureName().includes(inName)))
    // } else
      if (fromCartItemName.includes("2cm")) {
      feature = featureCollection.features.find(currentFeature => currentFeature.getSplittedFeatureName().includes("2cm"))
    } else if (fromCartItemName.includes("3cm")) {
      feature = featureCollection.features.find(currentFeature => currentFeature.getSplittedFeatureName().includes("3cm"))
    }
  }
  if (!feature) {
    feature = featureCollection.features[0]; // take first collection feature
  }

  const totalPrice = +toFixedFeatureCost(feature, totalCountertopsQuantity, "");

  const countertopTotalPrice = +toFixedFeatureCost(cartItem.cartFeature, totalCountertopsQuantity, "");

  let subTotalPrice = getTotalPrice(quoteIndex, false).materialPrice;
  subTotalPrice = toFixedPrice(subTotalPrice - countertopTotalPrice + totalPrice);

  const filterGroup = filterGroups.find(fGroup => fGroup.name === SIMILAR_FILTER_GROUP_NAME);
  const filterGroupValue = getFilterGroupValue(featureCollection.id, filterGroup);
  if (!filterGroupValue || !filterGroupValue.displayText) {
    return null
  }
  const filterValueName = filterGroupValue.displayText.replace(" " + SIMILAR_FILTER_GROUP_NAME, "");

  return {
    filterValueName,
    feature,
    subTotalPrice,
  }
}
